import Papa from 'papaparse';

/*
 * CSV download for the /export response ({ exportHeader, exportScenarioData,
 * exportBusinessData }). Used by the Export page and the one-click business
 * case export.
 */

const amountDivisor = (amountSizing) => {
    switch (amountSizing) {
        case 'Thousands':        return 1_000;
        case 'HundredThousands': return 100_000;
        case 'Millions':         return 1_000_000;
        case 'Units':
        default:                 return 1;
    }
};

/** A file name without the characters Windows and macOS refuse. */
export const safeFileName = (name, fallback = 'Export') =>
    String(name ?? '')
        .replace(/[\\/:*?"<>|]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim() || fallback;

/** Downloads the export as "<fileName>.csv", scaled and formatted for the organization. */
export const downloadExportCsv = (data, organization, fileName = 'CSV Export File') => {
    const isEuropean = organization?.notation === 'European';
    const delimiter = ';';
    const divisor = amountDivisor(organization?.amountSizing);

    const cleanNumber = (cell) => {
        if (typeof cell !== 'string') return cell;
        if (!/^-?\d+(\.\d+)?$/.test(cell)) return cell;
        const n = Number(cell);
        if (!Number.isFinite(n)) return cell;
        const scaled = n / divisor;
        // Round away convergence noise (6 decimals is plenty for financials)
        const rounded = Math.round(scaled * 1e6) / 1e6;
        const str = rounded.toString();
        return isEuropean ? str.replace('.', ',') : str;
    };

    const rows = [...(data.exportScenarioData || []), ...(data.exportBusinessData || [])]
        .map((row) => row.map(cleanNumber));

    const csv = Papa.unparse(
        { fields: data.exportHeader, data: rows },
        { delimiter }
    );

    const csvData = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(csvData);
    a.download = `${safeFileName(fileName)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 0);
};
